(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["private-events-intake-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.private-events-intake__form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const honeypot = form.querySelector('[name="contact[website]"]');
      if (honeypot && honeypot.value.trim() !== '') {
        event.preventDefault();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["private-events-offerings"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class PrivateEventsOfferings extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length || !this.panels.length) return;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
        });
      }

      activate(tab) {
        const panelId = tab.getAttribute('aria-controls');
        if (!panelId) return;

        this.tabs.forEach((item) => {
          const isSelected = item === tab;
          item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          item.classList.toggle('private-events-offerings__tab--active', isSelected);
          item.tabIndex = isSelected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });
      }

      onKeydown(event, tab) {
        const index = this.tabs.indexOf(tab);
        let nextIndex = index;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault();
          nextIndex = (index + 1) % this.tabs.length;
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          event.preventDefault();
          nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        } else if (event.key === 'Home') {
          event.preventDefault();
          nextIndex = 0;
        } else if (event.key === 'End') {
          event.preventDefault();
          nextIndex = this.tabs.length - 1;
        } else {
          return;
        }

        this.tabs[nextIndex].focus();
        this.activate(this.tabs[nextIndex]);
      }
    }

    if (!customElements.get('private-events-offerings')) {
      customElements.define('private-events-offerings', PrivateEventsOfferings);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
